import * as React from 'react';
import { CenteredContentLayout } from '../../../components/containers/CenteredContentLayout';
import { LegacyIframeOptions, useLegacyIframe } from '../../../hooks/useLegacyIframe';
import { BoxNotification } from '../../../components/containers/BoxNotification';

export const BusinessDetailsView = (): JSX.Element => {
  const options: LegacyIframeOptions = {
    title: 'Business Details',
    src: `https://${window.location.hostname}/business_details`,
    whiteListedPaths: [/^\/business_details/, /^\/contact/]
  };
  const { loading, error, iframe } = useLegacyIframe(options);

  return (
    <>
      {loading && (
        <CenteredContentLayout loading={true} hasSidebar>
          <></>
        </CenteredContentLayout>
      )}
      {error && (
        <CenteredContentLayout hasSidebar>
          <div className={'grid-x margin-top-small-32'}>
            <BoxNotification type={'error'}>Sorry, something went wrong loading this content</BoxNotification>
          </div>
        </CenteredContentLayout>
      )}
      {!error && iframe}
    </>
  );
};
